import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useCanViewPersonalizations from 'personalization-lib/hooks/auth/useCanViewPersonalizations';
const useFromPersonalizationParam = () => {
  const {
    search
  } = useLocation();
  const hasPersonalizationAccess = useCanViewPersonalizations();
  return useMemo(() => {
    const params = new URLSearchParams(search);
    const strategyId = params.get('fromPersonalizationStrategyId');
    return strategyId && hasPersonalizationAccess ? Number(strategyId) : undefined;
  }, [search, hasPersonalizationAccess]);
};
export default useFromPersonalizationParam;